<template>
  <div id="app" :style="img_path">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  computed: {
    img_path() {
      return {
        "--IMGPATH":
          "url('" +
          process.env.IMG_PATH +
          "/a01/common/empty.png') no-repeat center",
      };
    },
  },
};
</script>

<style>
#app {
  font-family: Arial, Helvetica Neue, Helvetica, PingFang SC, Tahoma, sans-serif;
}

body .el-table__empty-block:before {
  display: block;
  content: "";
  width: 100%;
  height: 86px;
  background: var(--IMGPATH);
}
</style>



// WEBPACK FOOTER //
// src/App.vue